var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:_vm.id,staticClass:"lazyload",attrs:{"id":_vm.id,"data-sizes":"auto","data-src":_vm.imageSizedUrl,"alt":_vm.altHandleNull}})}
var staticRenderFns = []

export { render, staticRenderFns }